import { render } from "./EnRules.vue?vue&type=template&id=ec4a3322&scoped=true"
import script from "./EnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./EnRules.vue?vue&type=script&scoped=true&lang=js"

import "./EnRules.vue?vue&type=style&index=0&id=ec4a3322&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec4a3322"

export default script